import { chartList, newReleases, trendingTags } from '@/mocks/site';

const trendIcon: Record<string, string> = {
  up: 'ri-arrow-up-line text-primary-600',
  down: 'ri-arrow-down-line text-secondary-600',
  flat: 'ri-subtract-line text-foreground-400',
};

export default function ChartSection() {
  return (
    <section id="charts" className="scroll-mt-20 bg-background-100">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-1.5 text-xs font-medium tracking-widest text-accent-700 uppercase">
            <i className="ri-trophy-line"></i> CHARTS
          </span>
          <h2 className="mt-2 font-heading text-2xl md:text-3xl font-bold text-foreground-950">热播排行榜</h2>
          <p className="mt-2 text-sm text-foreground-600">
            综合下载热度、评价人数与更新情况动态排序，反映近期最受关注的影片。榜单页每周整体刷新一次，可作为找片时的参考。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 lg:grid-cols-3 gap-5">
          <div className="lg:col-span-2 rounded-lg border border-background-200 bg-background-50 overflow-hidden">
            <div className="px-5 py-4 border-b border-background-200 flex items-center justify-between">
              <h3 className="text-sm font-semibold text-foreground-900">综合热度 TOP 10</h3>
              <span className="text-[11px] text-foreground-500">更新于 10-09</span>
            </div>
            <ul>
              {chartList.map((item, i) => (
                <li
                  key={item.title}
                  className="flex items-center gap-3 md:gap-4 px-4 md:px-5 py-3 border-b border-background-100 last:border-0 hover:bg-primary-50/50 transition-colors"
                >
                  <span
                    className={`w-7 h-7 shrink-0 rounded-md flex items-center justify-center font-heading text-sm font-bold ${
                      i < 3 ? 'bg-primary-500 text-background-50' : 'bg-background-100 text-foreground-500'
                    }`}
                  >
                    {i + 1}
                  </span>
                  <div className="min-w-0 flex-1">
                    <p className="text-sm font-medium text-foreground-900 truncate">{item.title}</p>
                    <p className="text-xs text-foreground-500 mt-0.5 truncate">{item.meta}</p>
                  </div>
                  <span className="hidden sm:flex items-center gap-1.5 w-28">
                    <span className="flex-1 h-1.5 rounded-full bg-background-200 overflow-hidden">
                      <span className="block h-full rounded-full bg-accent-500" style={{ width: `${item.heat}%` }}></span>
                    </span>
                  </span>
                  <span className="w-10 text-right text-sm font-semibold text-accent-700">{item.rating.toFixed(1)}</span>
                  <i className={`${trendIcon[item.trend]} text-lg`}></i>
                </li>
              ))}
            </ul>
          </div>

          <div className="flex flex-col gap-5">
            <div className="rounded-lg border border-background-200 bg-background-50 overflow-hidden">
              <div className="px-5 py-4 border-b border-background-200 flex items-center gap-2">
                <i className="ri-flashlight-line text-secondary-600"></i>
                <h3 className="text-sm font-semibold text-foreground-900">新片速递</h3>
              </div>
              <ul className="p-3 flex flex-col gap-1">
                {newReleases.map((r) => (
                  <li key={r.title} className="flex items-center gap-3 px-2 py-2 rounded-md hover:bg-background-100 transition-colors">
                    <div className="min-w-0 flex-1">
                      <p className="text-sm text-foreground-900 truncate">{r.title}</p>
                      <p className="text-xs text-foreground-500 mt-0.5 truncate">{r.meta}</p>
                    </div>
                    <span className="shrink-0 px-2 py-0.5 rounded-full bg-secondary-50 border border-secondary-200 text-[11px] text-secondary-700 whitespace-nowrap">
                      {r.badge}
                    </span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="rounded-lg border border-background-200 bg-background-50 p-5">
              <h3 className="text-sm font-semibold text-foreground-900 flex items-center gap-2">
                <i className="ri-price-tag-3-line text-accent-600"></i>
                热门检索标签
              </h3>
              <div className="mt-4 flex flex-wrap gap-2">
                {trendingTags.map((t) => (
                  <span key={t} className="px-3 py-1.5 rounded-full bg-background-100 border border-background-200 text-xs text-foreground-600 hover:border-accent-300 transition-colors">
                    {t}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}